import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { pick, prop } from 'ramda';
import { getURLParams, getCleanUrl } from 'js/utils/url.util';
import { useAppSelector, usePageSelector } from 'js/store/hooks';

import { useTriggerCondition } from '../../Emitter';
import { getBasicCondition } from '../../../helpers';
import { BASIC_TAG_LAUNCH_CONDITION } from '../../../constants';

export const useTriggerAfterPageRendered = () => {
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const [isOnPageRenderedDone, setIsOnPageRenderedDone] = useState(false);
    const { isPageRendered, friendlyURL, path } = usePageSelector(pick(['isPageRendered', 'friendlyURL', 'path']));
    const triggerCondition = useTriggerCondition();
    // this is needed to handle "forward root page" checkbox in Predefined pages -> Default Pages
    let page = friendlyURL || path && getCleanUrl(path);

    if (page === '/') {
        page = rootPage;
    }

    // this lock is needed since path is changed earlier than isPageRendered.
    // it leads to additional unnecessary trigger upon navigation.
    useEffect(() => {
        if (!isPageRendered) {
            setIsOnPageRenderedDone(false);
        }
    }, [isPageRendered]);

    useEffect(() => {
        if (page && isPageRendered && !isOnPageRenderedDone) {
            triggerCondition(getBasicCondition({
                launch: BASIC_TAG_LAUNCH_CONDITION.afterPageRendered,
                page,
                urlParams: getURLParams(location.search)
            }));
            setIsOnPageRenderedDone(true);
        }
    }, [isPageRendered, triggerCondition, page, isOnPageRenderedDone, location.search]);
};
